import React from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'

const UnbindWechat = (props) => {
  const handleOk = () => {
    axios.post('/c/kf_b/wechatmp/unbind')
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('解绑成功！')
          props.isCancel()
          props.fetchAcountDetail()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  return (
    <Modal 
      title="关闭消息通知"
      open={props.isOpen}
      onOk={handleOk}
      onCancel={props.isCancel}
      cancelText="取消"
      okType='danger'
      okText='关闭'>

      <p>关闭后将不在收到微信公众号的消息通知，是否确认关闭？</p>
    </Modal>
  )
}

export default UnbindWechat
